var _path, _path2, _path3, _path4, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdateIconActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6771 9.9784L13.1958 8.65286L13.9539 11.5461",
    stroke: "#14121F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38258 5.74938L2.80375 7.34682L2.0456 4.45358",
    stroke: "#14121F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7988 9.50323C12.6046 10.4455 12.1387 11.3186 11.4481 12.0091C10.5179 12.9393 9.25624 13.4619 7.94069 13.4619C6.62514 13.4619 5.36346 12.9393 4.43323 12.0091C3.85764 11.4335 3.43811 10.731 3.20189 9.96737",
    stroke: "#14121F",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20117 6.49677C3.39545 5.55455 3.86135 4.68143 4.55185 3.99092C5.48209 3.06069 6.74376 2.53809 8.05931 2.53809C9.37486 2.53809 10.6365 3.06069 11.5668 3.99093C12.1424 4.56652 12.5619 5.269 12.7981 6.03263",
    stroke: "#14121F",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.04395,
    cy: 7.98926,
    r: 2,
    fill: "#45D245"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateIconActive);
export default __webpack_public_path__ + "static/media/update-icon-active.f6b79d5e3cb07e5f6a76ae65d19d88ba.svg";
export { ForwardRef as ReactComponent };